import React from 'react';
import { TableSelectColumnHeaderTemplate } from 'themes/components';

function TableSelectColumnHeader(props) {
    return (
        <TableSelectColumnHeaderTemplate {...props} />
    )
}

export default TableSelectColumnHeader;